import React, { useEffect, useState } from 'react';
import { GetProcessPaymentJson } from '../services/PaymentService';
import { MainGestor_v1 } from '../services/MainGestorService';
import AuthorizingPayment from '../components/AuthorizingPayment';
import RejectedPayment from '../components/RejectedPayment';
import AuthorizedPayment from '../components/AuthorizedPayment';
//import { generate_jwt } from '../utils/GenerateJWT';
import { generate_jwt_cyber } from '../utils/GenerateJWTCyber';
import { CreateLog } from '../services/CreateLogsService';

function StartPage() {
  const [orderReferenceNumber, setOrderReferenceNumber] = useState(null);
  const [urlRedirect, setUrlRedirect] = useState('');
  const [totAmount, setTotAmount] = useState(0);
  const [status, setStatus] = useState('loading');
  const [CCNumber, setCCNumber] = useState('');
  const [flagSetcURL, setflagSetcURL] = useState(false);
  const [flagEstatusTran, setFlagEstatusTran] = useState('');
  const [flagSETC, setFlagSETC] = useState(false);

  const searchParams = React.useMemo(() => new URLSearchParams(window.location.search), []);
  const transactionId = searchParams.get('transactionId');
  const hasFetched = React.useRef(false);


  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;


    if (!transactionId) {
      setStatus('error');
      return;
    }

    setFlagEstatusTran(searchParams.get('flagEstatusTran') || '');
    setCCNumber(searchParams.get('payType') || '');
    setflagSetcURL(searchParams.get('flagSetc') || false);

    const fetchData = async () => {
      try {
        const data = await GetProcessPaymentJson(transactionId);
        const shipments = data.shipments || [];
       
        shipments.forEach(shipment => {
          if(shipment.shippingReferenceNumber.trim().split('-')[1] === "1") {
            setFlagSETC(true);
          }
        });

        setOrderReferenceNumber(data.orderReferenceNumber);
        setTotAmount(data.total || 0);
        setUrlRedirect(data.returnURL || '');
        setStatus('authorizing');
      } catch (error) {
        setStatus('error');
        setTimeout(() => {
          window.location.assign(urlRedirect);
        }, 5000); 
      }
    };

    fetchData();
  }, [searchParams, transactionId, urlRedirect]);

  const initSoriana = React.useCallback(() => {
    const fetchJWT = async () => {
      //antigua implementaciones jwt
      //const jwt = await generate_jwt(transactionId);

      //nueva implementaciones jwt
      const jwt = await generate_jwt_cyber(transactionId, orderReferenceNumber,"mg");
      await CreateLog(transactionId, orderReferenceNumber, "JWT Generado", jwt);

      if(jwt === "") {
        setStatus('error');
        setTimeout(() => {
          window.location.assign(urlRedirect);
        }, 5000); 
      }

      const orderObject = {
        Consumer: {
          Account: {
            AccountNumber: CCNumber,
          }
        }
      };

      if (window.Cardinal && jwt && orderObject!== null) {
        console.log('Cardinal disponible, configurando...');
        window.Cardinal.configure({
          timeout: 6000,
          extendedTimeout: 4000,
          maxRequestRetries: 2,
          logging: {
            level: 'verbose'
          }
        });

        window.Cardinal.off && window.Cardinal.off();

        window.Cardinal.setup('init', {
          jwt: jwt,
          order: orderObject
        });

        window.Cardinal.on('payments.setupComplete', async () => {
          console.log('Setup completo, solicitando datos 3DS al backend');
          const referenceId = window.referenceId;
          const fetchJson = async () => {
            try {
              const json = await MainGestor_v1(transactionId, null, 1, null, null, referenceId, null);

              if(json.success){
                if(json.sec_3ds){
                  await CreateLog(transactionId, orderReferenceNumber, "cardinal payments.setupComplete", "");
                  window.ACSURL = json.acsurl;
                  window.PAReq = json.paReq;
                  window.TransactionIDAuth = json.transactionID;

                  Authenticate();
                }
                else{
                  setStatus('success');
                  await CreateLog(transactionId, orderReferenceNumber, "Redirect payments.setupComplete", "");

                  setTimeout(() => {
                    window.location.assign(json.url);
                  }, 5000); 
                }
              } else{
                await CreateLog(transactionId, orderReferenceNumber, "Error payments.setupComplete", json.message);
                setStatus('error');
                setTimeout(() => {
                  window.location.assign(urlRedirect);
                }, 5000);
              }
            } catch (error) {
              await CreateLog(transactionId, orderReferenceNumber, "Exception payments.setupComplete", error.message);
              setStatus('error');
              setTimeout(() => {
                window.location.assign(urlRedirect);
              }, 5000); 
            }
          };

          fetchJson();
        });

        function Authenticate() {
          window.Cardinal.continue('cca',
            {
              "AcsUrl": window.ACSURL,
              "Payload": window.PAReq
            },
            {
              "OrderDetails": {
                  "TransactionId": window.TransactionIDAuth
              }
            }
          );
        }

        window.Cardinal.on('payments.validated', async function (data, jwt) {
          console.log('Validación de pagos completada');
          await CreateLog(transactionId, orderReferenceNumber, "Cardinal Response payments.validated:", JSON.stringify(data, null, '    '));
          const referenceId = window.referenceId;

          if (data.ErrorDescription !== 'Success') {
            setStatus('error');
            setTimeout(function () {
              window.location.assign(urlRedirect);
            }, 10000);
          }

          try {
            const json = await MainGestor_v1(transactionId, null, null, 1, data.Payment.ProcessorTransactionId, referenceId, null);

            if(json.success){
              await CreateLog(transactionId, orderReferenceNumber, "Redirect Response true payments.validated", "");
              setStatus('success');

              setTimeout(() => {
                window.location.assign(json.url);
              }, 5000);
            } else{
              await CreateLog(transactionId, orderReferenceNumber, "Redirect Response false payments.validated", "");
              setStatus('error');

              setTimeout(() => {
                window.location.assign(urlRedirect);
              }, 5000);
            }
          }
          catch (error) {
            await CreateLog(transactionId, orderReferenceNumber, "Exception payments.validated", error.message);
            setStatus('error');

            setTimeout(() => {
              window.location.assign(urlRedirect);
            }, 5000); 
          }

          
        });

      } else {
        await CreateLog(transactionId, orderReferenceNumber, "Cardinal no disponible o faltan datos", orderObject);
        console.error('Cardinal no disponible o faltan datos');
      }
    };

    fetchJWT();
  }, [transactionId, orderReferenceNumber, CCNumber, urlRedirect]);

    const initSorianaSetc = React.useCallback(() => {
    const fetchJWT = async () => {

      const jwt = await generate_jwt_cyber(transactionId, orderReferenceNumber,"setc");
      await CreateLog(transactionId, orderReferenceNumber, "JWT Generado", jwt);

      if(jwt === "") {
        setStatus('error');
        setTimeout(() => {
          window.location.assign(urlRedirect);
        }, 5000); 
      }

      const orderObject = {
        Consumer: {
          Account: {
            AccountNumber: CCNumber,
          }
        }
      };

      if (window.Cardinal && jwt && orderObject!== null) {
        console.log('Cardinal disponible, configurando...');
        window.Cardinal.configure({
          timeout: 6000,
          extendedTimeout: 4000,
          maxRequestRetries: 2,
          logging: {
            level: 'verbose'
          }
        });

        window.Cardinal.off && window.Cardinal.off();

        window.Cardinal.setup('init', {
          jwt: jwt,
          order: orderObject
        });

        window.Cardinal.on('payments.setupComplete', async () => {
          console.log('Setup completo, solicitando datos 3DS al backend');
          const referenceId = window.referenceId;
          const fetchJson = async () => {
            try {
              const json = await MainGestor_v1(transactionId, null, 1, null, null, referenceId, null);

              if(json.success){
                if(json.sec_3ds){
                  await CreateLog(transactionId, orderReferenceNumber, "cardinal payments.setupComplete", "");
                  window.ACSURL = json.acsurl;
                  window.PAReq = json.paReq;
                  window.TransactionIDAuth = json.transactionID;

                  Authenticate();
                }
                else{
                  setStatus('success');
                  await CreateLog(transactionId, orderReferenceNumber, "Redirect payments.setupComplete", "");

                  setTimeout(() => {
                    window.location.assign(json.url);
                  }, 5000); 
                }
              } else{
                await CreateLog(transactionId, orderReferenceNumber, "Error payments.setupComplete", json.message);
                setStatus('error');
                setTimeout(() => {
                  window.location.assign(urlRedirect);
                }, 5000);
              }
            } catch (error) {
              await CreateLog(transactionId, orderReferenceNumber, "Exception payments.setupComplete", error.message);
              setStatus('error');
              setTimeout(() => {
                window.location.assign(urlRedirect);
              }, 5000); 
            }
          };

          fetchJson();
        });

        function Authenticate() {
          window.Cardinal.continue('cca',
            {
              "AcsUrl": window.ACSURL,
              "Payload": window.PAReq
            },
            {
              "OrderDetails": {
                  "TransactionId": window.TransactionIDAuth
              }
            }
          );
        }

        window.Cardinal.on('payments.validated', async function (data, jwt) {
          console.log('Validación de pagos completada');
          await CreateLog(transactionId, orderReferenceNumber, "Cardinal Response payments.validated:", JSON.stringify(data, null, '    '));
          const referenceId = window.referenceId;

          if (data.ErrorDescription !== 'Success') {
            setStatus('error');
            setTimeout(function () {
              window.location.assign(urlRedirect);
            }, 10000);
          }

          try {
            const json = await MainGestor_v1(transactionId, null, null, 1, data.Payment.ProcessorTransactionId, referenceId, null);

            if(json.success){
              await CreateLog(transactionId, orderReferenceNumber, "Redirect Response true payments.validated", "");
              setStatus('success');

              setTimeout(() => {
                window.location.assign(json.url);
              }, 5000);
            } else{
              await CreateLog(transactionId, orderReferenceNumber, "Redirect Response false payments.validated", "");
              setStatus('error');

              setTimeout(() => {
                window.location.assign(urlRedirect);
              }, 5000);
            }
          }
          catch (error) {
            await CreateLog(transactionId, orderReferenceNumber, "Exception payments.validated", error.message);
            setStatus('error');

            setTimeout(() => {
              window.location.assign(urlRedirect);
            }, 5000); 
          }

          
        });

      } else {
        await CreateLog(transactionId, orderReferenceNumber, "Cardinal no disponible o faltan datos", orderObject);
        console.error('Cardinal no disponible o faltan datos');
      }
    };

    fetchJWT();
  }, [transactionId, orderReferenceNumber, CCNumber, urlRedirect]);


  useEffect(() => {
    if (status !== 'authorizing') return;

    switch (flagEstatusTran) {
      case 'ENROLLMENT':

        if(flagSetcURL){
          if(flagSETC){
            CreateLog(transactionId, orderReferenceNumber, "3DS setc tarjeta", "");
            initSorianaSetc();
            
            //3DS setc tarjeta initSoriana()
          } else{
            // 3DS soriana_mx tarjeta
            initSoriana();
          }
        }

        break;
      default:
        console.log('Otro flujo, iniciar contador o monitoreo');
        break;
    }
  }, [status, flagEstatusTran, CCNumber, flagSetcURL, flagSETC, transactionId, orderReferenceNumber, initSoriana, initSorianaSetc]);



  return (
    <div>
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-9 ml-8 mr-8 rounded-xl shadow-md text-center w-auto max-w-[800px] h-auto max-h-[800px]">
          {(status === 'authorizing' || status === 'loading') && (
            <AuthorizingPayment orderReferenceNumber={orderReferenceNumber} />
          )}
          {status === 'success' && (
            <AuthorizedPayment
              orderReferenceNumber={orderReferenceNumber}
              urlRedirect={urlRedirect}
              orderAmount={totAmount}
            />
          )}
          {status === 'error' && <RejectedPayment urlRedirect={urlRedirect} />}
        </div>
      </div>

      {/* nueva implementaciones jwt
       Elementos ocultos para Cardinal */}
      
      <iframe id="cardinal_collection_iframe" name="collectionIframe" height="10" width="10" style={{ display: 'none' }}
        title="Cardinal Collection Iframe"></iframe>
      <form id="cardinal_collection_form" method="POST" target="collectionIframe" action="https://centinelapistag.cardinalcommerce.com/V1/Cruise/Collect">
        <input id="cardinal_collection_form_input" type="hidden" name="JWT"/>
      </form>
      

    </div>
  );
}

export default StartPage;
